import React from 'react';

const {FacebookIcon, TwitterIcon, InstagramIcon} = polyphony.icons;
const {useSelector, useA11yButton} = polyphony.hooks;
const {prefixCSS} = polyphony.css;

const FollowUsLink = ({url, label, icon: Icon, color, isLast, isEditor}) => {
    const [{hover}, ref] = useA11yButton({
        'aria-label': label
    });

    return <a ref={ref} href={isEditor ? undefined : url}
              style={{cursor: isEditor ? 'not-allowed' : undefined,
                      backgroundColor: hover ? 'white' : color,
                      border: `1px solid ${color}`,
                      boxSizing: 'border-box',
                      width: 44, height: 44,
                      marginRight: isLast ? undefined : 22}}>
        <Icon width='100%' height='100%' style={{color: hover ? color : 'white', boxSizing: 'border-box', padding: 10}}/>
    </a>;
};

const FollowUsBlock = ({gutenberg:{isEditor}}) => {
    const {twitter_url, facebook_url, instagram_url, button_color} = useSelector(({social}) => social);

    const links = [];
    if (facebook_url) links.push(<FollowUsLink label='Facebook' key='facebook' isEditor={isEditor} color={button_color} url={facebook_url} icon={FacebookIcon} />);
    if (instagram_url) links.push(<FollowUsLink label="Instagram" key='instagram' isEditor={isEditor} color={button_color} url={instagram_url} icon={InstagramIcon} />);
    if (twitter_url) links.push(<FollowUsLink label="Twitter" key='twitter' isEditor={isEditor} color={button_color} url={twitter_url} icon={TwitterIcon} />);

    if (links.length > 0) {
        links[links.length - 1] = React.cloneElement(links[links.length - 1], {isLast: true});
    }

    return <div style={prefixCSS({display: 'flex', flexFlow: 'row nowrap', width: '100%', justifyContent: 'center'})}>
        {links}
    </div>;
};

FollowUsBlock.title = "Follow Us";
FollowUsBlock.icon = 'wp';
FollowUsBlock.category = 'layout';

export default FollowUsBlock;

